import { toPersian } from "./raqam";

export const appStrings = {
  brand: "کوییز قنداق",
  about: "درباره ما",
  widgetAdTitle: "از ابزارک‌های قنداق لذت ببرید!",
  widgetAdDesc:
    "قنداق علاوه بر کوییزای بامزه، سرویس‌ها و ابزارک‌های متنوع و کاربردی دیگه ای هم داره که می‌تونید با کلیک کردن روی لینک زیر از اونا هم استفاده کنید!",
  showWidgets: "مشاهده ابزارک‌ها",
  showAllQuizes: "مشاهده تمام کوییزها",
  otherQuizzes: "دیدن بقیه کوییز ها",
  stats: "در یک نگاه",
  totalQuizzes: "تعداد کوییزها",
  totalUsers: "تعداد کاربران",
  totalDoneQuizzes: "دفعات انجام کوییزها",
  totalProblems: "تعداد کل سوالات",
  popularQuiz: "محبوب ترین کوییزها",
  popularDesc: (quizName: string) =>
    `"${quizName}"، محبوب ترین کوییز سامانه قنداقه!`,
  navTitle: "به سامانه کوییز قنداق خوش آمدید!",
  darkMode: "حالت تاریک",
  tryAgain: "تلاش مجدد",
  defaultError: "متاسفانه برقراری ارتباط با سرور با مشکل مواجه شده است.",
  problemCount: "تعداد سوالات",
  progressPercentage: "درصد پیشرفت",
  quizSelectionHint: "جهت شروع، یکی از کوییزهای زیر را انتخاب نمایید.",
  question: "سوال",
  start: "شروع",
  loading: "در حال ثبت...",
  submitAnswer: "تایید",
  next: "سوال بعد",
  back: "بازگشت",
  showResult: "مشاهده نتیجه",
  finish: "پایان",
  correct: "درسته!",
  wrong: "متاسفانه جواب اشتباه زدید! جواب درست:",
  authHint:
    "از اینکه وقت گذاشتید و کوییز رو تموم کردید ممنونیم! برای دیدن نتیجه کوییز لطفا فرم زیر رو کامل کنید! همچنین، با کامل کردن فرم زیر خیالتون راحته که از مشاوره های آتی ما بی خبر نمی مونید.",
  name: "نام و نام خانوادگی",
  namePlaceholder: "مثلا رعنا صادقی",
  email: "ایمیل",
  emailPlaceholder: "email@domain.com",
  yourScore: "امتیاز شما:",
  scoreDivision: (score: number, max: number) =>
    `${toPersian(score, {})} از ${toPersian(max, {})}`,
  copyright: "تمامی حقوق این سامانه متعلق به قنداق می باشد.",
  lorem:
    "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و متخصصان را می طلبد، تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی، و فرهنگ پیشرو در زبان فارسی ایجاد کرد، در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها، و شرایط سخت تایپ به پایان رسد و زمان مورد نیاز شامل حروفچینی دستاوردهای اصلی، و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.",
  finalThanks:
    "از این که در این کوییز شرکت کردین ممنونیم! بازم به ما سر بزنید!",
  requiredFieldsError: "لطفا تمامی اطلاعات خواسته شده را وارد نمایید",
  sanctum: "خطا در ارتباط با سرور",
  auth: "ورود/ثبت نام",
  analyzeHint:
    "کاربر گرامی! جهت مشاهده تحلیل کوییز خود می‌توانید بر روی لینک زیر کلیک نمایید. توجه داشته باشید در صورتی که وارد حساب کاربری خود نشده باشید، به صفحه ورود منتقل خواهید شد و پس از ورود موفق، نتیجه را مشاهده خواهید کرد.",
  showAnalyze: "مشاهده تحلیل آزمون",
  avgScore: "میانگین امتیاز دیگر کاربران در این کوییز:",
  descAdTitle: "با کوییز دادن اطلاعاتتون رو بیشتر کنید!",
  descAdDesc:
    "درباره بارداری و مراقبت از نوزاد کوچولوتون با سوالات زیادی مواجهید؟ کوییز های کوتاه و بامزه ما رو جواب بدید و در کنارش کلی اطلاعات به دست بیارید!",
};
